import { httpClient } from 'angieslist-app-platform';

export const getAgreement = (agreementId, token) => {
  const response = httpClient.post(
    '/gateway/advertising/v3/agreements',
    {
      body: { agreementIds: [agreementId] },
      headers: {
        Authorization: 'OneTime '.concat(token),
      },
    },
  );
  return response;
};

export const acceptAgreement = (
  agreementId,
  initials: string,
  token,
) => {
  const response = httpClient.post(
    '/gateway/advertising/v1/agreement/accept',
    {
      body: { agreementId, initials },
      headers: {
        Authorization: 'OneTime '.concat(token),
      },
    },
  );

  return response;
};
export const updatePaymentProfile = (agreementId, paymentProfileId, token) => httpClient.put(
  `/gateway/advertising/v1/agreement/${agreementId}/paymentInfo`,
  {
    body: {
      paymentProfileId,
    },
    headers: {
      Authorization: 'OneTime '.concat(token),
    },
  },
);

export const getOpportunityOwners = (agreementId, token) => {
  const response = httpClient.post(
    '/gateway/advertising/v1/agreement/opportunityOwners',
    {
      body: { agreementIds: [agreementId] },
      headers: {
        Authorization: 'OneTime '.concat(token),
      },
    },
  );
  return response;
};

export const fetchAgreementsByServiceProviderId = (
  spId,
  lastUpdatedDate,
) => {
  const response = httpClient.get(`/gateway/advertising/v1/serviceprovider/${spId}/agreements?lastUpdatedDate=${lastUpdatedDate}`);
  return response;
};



// WEBPACK FOOTER //
// ./src/modules/adAgreement/common/advertising-gateway/advertisingService.js